module.exports = __webpack_public_path__ + "img/dinersclub-small.d780db36.svg";